import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=f1e900b8&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=f1e900b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1e900b8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f1e900b8')) {
      api.createRecord('f1e900b8', component.options)
    } else {
      api.reload('f1e900b8', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=f1e900b8&scoped=true&", function () {
      api.rerender('f1e900b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Na7rLZPOiSnK/JS/comp/DocBox.vue"
export default component.exports